import { loader } from 'graphql.macro'

export default async function createInvoiceV2 ({ dataLoaders, variables }) {
  const schema = loader('./createInvoiceV2.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.createInvoiceV2
}
